import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { MoreVertical, Share2, Edit, Trash2, Bot } from "lucide-react";
import { Button } from "./ui/button";
import { DeleteListDialog } from "./DeleteListDialog";
import { NostrEvent } from "@nostrify/nostrify";

interface ListActionsProps {
  listEvent: NostrEvent;
  onShare: () => void;
  onEdit: () => void;
  onDeleted: () => void;
  onEDHRec: () => void;
  isOwner: boolean;
  className?: string;
}

export function ListActions({
  listEvent,
  onShare,
  onEdit,
  onDeleted,
  onEDHRec,
  isOwner,
  className
}: ListActionsProps) {

  return (
    <div className={className}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" className="bg-transparent hover:bg-gray-200 dark:hover:bg-gray-700">
            <MoreVertical className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuItem onClick={onEDHRec}>
            <Bot className="mr-2 h-4 w-4" />
            <span>EDHREC</span>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={onShare}>
            <Share2 className="mr-2 h-4 w-4" />
            <span>Share</span>
          </DropdownMenuItem>
          {isOwner && (
            <>
              <DropdownMenuItem onClick={onEdit}>
                <Edit className="mr-2 h-4 w-4" />
                <span>Edit</span>
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DeleteListDialog listEvent={listEvent} onDeleted={onDeleted}>
                <DropdownMenuItem onSelect={(e) => e.preventDefault()} className="text-red-500 focus:text-red-500">
                  <Trash2 className="mr-2 h-4 w-4" />
                  <span>Delete</span>
                </DropdownMenuItem>
              </DeleteListDialog>
            </>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
